import * as amplitude from "@amplitude/analytics-react-native"

// The code and link logins get their method from the backend (`method`).
export const PASSWORD_LOGIN_METHOD = "password"

// Most specific first: an admin who is also a tutor counts as an admin.
const ROLE_PRECEDENCE = [
    "super-admin",
    "admin",
    "tutor",
    "tutor-candidate",
    "teacher",
    "school-admin",
    "referral-admin",
    "student",
    "parent",
]

const primaryRole = (roles) =>
    ROLE_PRECEDENCE.find((role) => roles?.includes(role)) ?? roles?.[0] ?? null

/**
 * The one event every successful login sends, whatever proved the identity —
 * it is how the share of code and link logins is measured, per role.
 * `design_system` says which login screens it came through: the share of SMS
 * logins is read before and after the switch, and on each if the cut-off serves.
 */
export const trackLoginSucceeded = (
    method,
    successData,
    { designSystem = false } = {}
) => {
    const openedIds = new Set([
        successData?.user?.id,
        ...(successData?.family_tokens ?? []).map((t) => t.user?.id),
    ])
    amplitude.track("login.succeeded", {
        method,
        role: primaryRole(successData?.user?.roles),
        accounts_count: [...openedIds].filter(Boolean).length,
        design_system: designSystem,
    })
}

/**
 * « Qui utilise Masteur ? » for a student or anyone who opened several
 * accounts, straight to the account's home otherwise — the password login's
 * rule, shared by every way in.
 */
export const needsAccountPicker = (successData) =>
    successData?.family_tokens?.length > 0 ||
    !!successData?.user?.roles?.includes("student")

export const mainAccountTokenData = (successData) => ({
    email: successData.user.email,
    token: successData.token,
    userId: successData.user.id,
    displayName: successData.user.display_name,
    firstname: successData.user.firstname,
    lastname: successData.user.lastname,
    roles: successData.user.roles,
    avatar: successData.user.avatar,
    title_skill_set_id: successData.user.title_skill_set_id,
    hubspot_id: successData.user.hubspot_id,
})

export const continueAfterLogin = (
    successData,
    { navigation, switchAccount }
) => {
    if (needsAccountPicker(successData))
        navigation.replace("family-account-selection")
    else switchAccount(mainAccountTokenData(successData))
}
